import {StyleSheet, PixelRatio} from 'react-native';

export default StyleSheet.create({
    accuratePriceField:{
        flexDirection: 'row',
        alignItems: 'baseline',
        justifyContent: 'flex-end',
        marginTop:2
    },
    priceDiscount:{
        fontFamily: "PingFangSC-Regular",
        fontSize: 10,
        color: "#999999",
        textAlign: "right",
        height: 14,
    },
    priceColor:{
        color: "#FF6600"
    },
    label:{
        backgroundColor: "#EBFFF8",
        borderTopLeftRadius: 0,
        borderTopRightRadius: 8,
        borderBottomLeftRadius: 8,
        borderBottomRightRadius: 0,
        paddingHorizontal:6,
        height: 14,
        top:0,
        right:0,
        position: 'absolute'
    },
    labelText:{
        fontFamily: "PingFangSC-Regular",
        fontSize: 10,
        color: "#00B87A",
        height: 14,
    },

    cheapList:{
        flex: 1
    },

    priceBaseInfo:{
        paddingHorizontal: 16
    },

    priceCardBlock:{
        flexDirection:'row',
        marginLeft: 8,
        marginRight: 16,
    },

    pictureCard:{
        flex: 1,
        backgroundColor: "#FFFFFF",
        borderRadius: 8,
        marginLeft:8,
        marginTop: 8,
        overflow: 'hidden'
    },

    pictureCardImg:{
        height: 100,
        backgroundColor: '#F1F2F4'
    },

    pictureCheapInfo:{
        paddingHorizontal: 8,
        paddingTop: 8,
        paddingBottom: 12,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-end'
    },

    pictureCardDiscount:{
        height: 16,
        width: 34,
        alignItems: 'center',
        justifyContent: 'center'
    },
    pictureCardDiscountImage:{
        width: '100%',
        height: '100%',
        position: 'absolute'
    },
    pictureCardDiscountText:{
        fontFamily: "PingFangSC-Regular",
        fontSize: 10,
        color: "#FF6600",
        maxWidth: 34,
        flexWrap: 'nowrap',
        height: 14,
        transform:[{scaleX: 0.9}, {scaleY: 0.9}]
    },

    picturePrefixSize:{
        fontFamily: "PingFangSC-Regular",
        fontWeight: 'bold',
        fontSize: 12,
        color: "#FF6600",
    },
    pictureCardPriceField:{
        alignItems:'flex-end'
    },

    pictureYuanSize:{
        fontFamily: "hotel_rn_num_v1",
        fontSize: 18,
        color: "#FF6600",
        height: 22
    },
    transformScale: {
        transform: [{ scale: 0.8 }],
        transformOrigin: '0% 50%'
    }
});